// --------------- TYPES ---------------
import { GetUsers, GetUser, UpdateUser, DeleteUser } from '../Types'

// --------------- ACTIONS ---------------

export const getUsers = {
  Request: (params) => ({
    type: GetUsers.REQUEST,
    params,
  }),
  Success: (data) => ({
    type: GetUsers.SUCCESS,
    payload: data,
  }),
  Failed: (error) => ({
    type: GetUsers.FAILED,
    payload: error,
  }),
}

export const getUser = {
  Request: (params) => ({
    type: GetUser.REQUEST,
    params,
  }),
  Success: (data) => ({
    type: GetUser.SUCCESS,
    payload: data,
  }),
  Failed: (error) => ({
    type: GetUser.FAILED,
    payload: error,
  }),
}

export const updateUser = {
  Request: (params) => ({
    type: UpdateUser.REQUEST,
    params,
  }),
  Success: (data) => ({
    type: UpdateUser.SUCCESS,
    payload: data,
  }),
  Failed: (error) => ({
    type: UpdateUser.FAILED,
    payload: error,
  }),
}

export const deleteUser = {
  Request: (params) => ({
    type: DeleteUser.REQUEST,
    params,
  }),
  Success: (data) => ({
    type: DeleteUser.SUCCESS,
    payload: data,
  }),
  Failed: (error) => ({
    type: DeleteUser.FAILED,
    payload: error,
  }),
}
